// @flow
import React, { PureComponent } from 'react';
import BrowserExtension from 'app/common/lib/BrowserExtension';
import ExtensionContentSimplePop from 'app/common/react/components/growth/activation/ExtensionUpsell/ExtensionContentSimplePop';
import i18n from 'app/common/lib/i18n';
import { track } from 'app/common/lib/react/analytics';
import { Box, Button, Divider, Heading, Text, Touchable } from 'gestalt';

type ExtProps = {|
  header: string,
  installClick: () => void,
  skipClick: () => void,
  subheader: string,
|};

export const ExtensionUI = ({ header, installClick, skipClick, subheader }: ExtProps) => (
  <Box direction="column" display="flex" height="100%" width="100%">
    <Box direction="column" display="flex" maxWidth={700} padding={8} wrap>
      <Heading size="xs">{header}</Heading>
      <Text size="xl">{subheader}</Text>
    </Box>
    <Box display="flex" flex="grow" margin={8}>
      <ExtensionContentSimplePop isLooping />
    </Box>
    <Divider />
    <Box
      alignItems="center"
      direction="column"
      display="flex"
      justifyContent="center"
      padding={4}
      width="100%"
    >
      <Button
        accessibilityLabel={i18n._(
          'Get the Pinterest browser extension',
          'Accesibility label for the Pinterest browser extension',
        )}
        color="red"
        onClick={installClick}
        text={i18n._('Get it now', 'Get the Pinterest browser extension')}
        size="lg"
      />
      <Box
        dangerouslySetInlineStyle={
          // adding underline to gestalt text; must set underline color too
          { __style: { color: '#8e8e8e', textDecoration: 'underline' } }
        }
        marginTop={4}
      >
        <Touchable onTouch={skipClick} mouseCursor="pointer">
          <Text bold color="gray">
            {i18n._('Skip')}
          </Text>
        </Touchable>
      </Box>
    </Box>
  </Box>
);

type OwnProps = {|
  fixSafariDetect?: boolean,
  handleComplete: () => void,
  handleDismiss: () => void,
|};

export default class ExtensionUpsell extends PureComponent<OwnProps> {
  componentDidMount() {
    track(PCONST.thrift.EventType.VIEW, {
      view: PCONST.thrift.ViewType.PIN,
      viewParameter: PCONST.thrift.ViewParameterType.EXTENSION_UPSELL_CLOSEUP,
    });
  }

  onInstallButtonClicked = () => {
    const { handleComplete } = this.props;
    BrowserExtension.handleExtensionInstall(handleComplete);

    track(PCONST.thrift.EventType.CLICK, {
      component: PCONST.thrift.ComponentType.BROWSER,
      element: PCONST.thrift.ElementType.INSTALL_EXTENSION_BUTTON,
      view: PCONST.thrift.ViewType.PIN,
      viewParameter: PCONST.thrift.ViewParameterType.EXTENSION_UPSELL_CLOSEUP,
    });
  };

  onSkipButtonClick = () => {
    const { handleDismiss } = this.props;
    track(PCONST.thrift.EventType.CLICK, {
      component: PCONST.thrift.ComponentType.BROWSER,
      element: PCONST.thrift.ElementType.SKIP_BUTTON,
      view: PCONST.thrift.ViewType.PIN,
      viewParameter: PCONST.thrift.ViewParameterType.EXTENSION_UPSELL_CLOSEUP,
    });
    handleDismiss();
  };

  render() {
    return (
      <ExtensionUI
        header={i18n._(
          'Get the Pinterest browser button',
          'Heading for downloading Pinterest chrome extension app',
        )}
        installClick={this.onInstallButtonClicked}
        skipClick={this.onSkipButtonClick}
        subheader={i18n._(
          'Save creative ideas from around the web.',
          'Subheader text for downloading Pinterest chrome extension app',
        )}
      />
    );
  }
}
